import { render, staticRenderFns } from "./sig.vue?vue&type=template&id=02b13136&"
import script from "./sig.vue?vue&type=script&lang=js&"
export * from "./sig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports